/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgRingcentral = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.74999 0H12.25C14.3203 0 16 1.67969 16 3.75001V12.25C16 14.3203 14.3203 16 12.25 16H3.74999C1.67967 16 0 14.3203 0 12.25V3.74999C0 1.67969 1.67969 0 3.74999 0Z'
      fill='#F18500'
    />
    <path
      d='M5.84531 2H10.1531C11.4906 2 11.975 2.13906 12.4641 2.39999C12.9531 2.66093 13.3359 3.0453 13.5985 3.53437C13.8594 4.02344 13.9984 4.50781 13.9984 5.84532V14H5.84531C4.50781 14 4.02343 13.861 3.53437 13.6C3.0453 13.3391 2.6625 12.9547 2.39999 12.4656C2.13906 11.9766 2 11.4922 2 10.1547V5.84532C2 4.50781 2.13906 4.02344 2.39999 3.53437C2.66093 3.0453 3.0453 2.6625 3.53437 2.39999C4.02343 2.13749 4.50781 2 5.84531 2Z'
      fill='white'
    />
    <path
      d='M5.07812 3.82031H10.9219C11.6203 3.82031 12.1875 4.38749 12.1875 5.08593V8.03907C12.1875 8.96407 11.3094 9.54376 10.6734 9.73126C10.9594 10.2703 11.4063 11.0875 12.0156 12.1797H9.95312L8.59218 9.82343H8.50313C8.34843 9.82343 8.22344 9.69844 8.22344 9.54374V7.89062H10.1219V5.88125H5.88125V9.48439C5.88125 10.0844 5.99842 11.1234 6.90624 12.1797H4.84374C4.08592 11.625 3.8125 10.4906 3.8125 9.82346V5.08595C3.81248 4.38751 4.37968 3.82031 5.07812 3.82031Z'
      fill='#0482BE'
    />
  </svg>
)
export default SvgRingcentral
